var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    style: {
      enableBackground: "new 0 0 31 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6,18.1c-1.7,0-3.3,0.7-4.4,1.8l-7.2-3.6c0-0.3,0.1-0.5,0.1-0.8c0-0.3,0-0.5-0.1-0.8l7.2-3.6c1.2,1.1,2.7,1.8,4.5,1.8 c3.6,0,6.5-2.9,6.5-6.4C31,2.9,28.1,0,24.6,0s-6.5,2.9-6.5,6.4c0,0.3,0,0.5,0,0.8l-7.2,3.6C9.7,9.7,8.2,9.1,6.5,9.1 C2.9,9.1,0,11.9,0,15.5C0,19.1,2.9,22,6.5,22c1.7,0,3.3-0.7,4.4-1.8l7.2,3.6c0,0.3-0.1,0.5-0.1,0.8c0,3.6,2.9,6.4,6.5,6.4 s6.5-2.9,6.5-6.4C31,21,28.1,18.1,24.6,18.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7ced11283ff145e088b8ac78726e80bf.svg";
export { ForwardRef as ReactComponent };